import { useLocation, useParams } from "react-router-dom";

/** Resolve workspace vs directory company detail route params. */
export function useCompanyDetailRoute() {
  const location = useLocation();
  const params = useParams<{
    accountId?: string;
    companyId?: string;
    tab?: string;
  }>();
  const isMutable = location.pathname.startsWith("/user/accounts");
  const detailId = isMutable ? params.accountId : params.companyId;
  const companiesBase: "/user/accounts" | "/companies" = isMutable
    ? "/user/accounts"
    : "/companies";
  return {
    detailId,
    isMutable,
    companiesBase,
    tab: params.tab,
  };
}
